import React, { useRef, useState, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import "../login/logincss/Login.css";

import logo from "../../images/auravit_logo.png";

import { auth, db } from "../../firebase";

import { signOut } from "firebase/auth";

import {

  clearPendingAccountReactivation,
  clearStoredLoginOtpChallenge,
  finalizePendingAccountReactivation,
  getPendingAccountReactivation,
  refreshStoredLoginOtpChallenge,
  verifyStoredLoginOtp,

} from "../../services/authFlowService";

import { sendOtpEmail, sendOtpSms, createOtpRequestId, generateOtpCode } from "../../services/otpService";

import { sessionService } from "../../services/sessionService";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore"; 

 

export default function AdminVerification() { 

  const location = useLocation(); 

  const navigate = useNavigate(); 

  const emailDisplay = 

    location.state?.otpEmail || 

    location.state?.user?.email || 

    location.state?.email || 

    "your registered email";

  const normalizePhoneNumber = (phone) => {
    if (!phone) return null;
    const cleaned = String(phone).replace(/\D/g, '');
    
    if (cleaned.length === 10 && cleaned.startsWith('9')) {
      return `+63${cleaned}`;
    } else if (cleaned.length === 11 && cleaned.startsWith('0')) {
      return `+63${cleaned.slice(1)}`;
    } else if (cleaned.length === 12 && cleaned.startsWith('63')) {
      return `+${cleaned}`;
    } else if (phone.startsWith('+63')) {
      return phone;
    }
    return null;
  }; 

 

  const OTP_LENGTH = 6; 

  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill("")); 

  const [error, setError] = useState(""); 

  const [isVerifying, setIsVerifying] = useState(false); 

  const [timeLeft, setTimeLeft] = useState(60); 

  const [otpExpired, setOtpExpired] = useState(false); 

  const [resendText, setResendText] = useState("Resend"); 

  const inputsRef = useRef([]);
  const [verificationMethod, setVerificationMethod] = useState("email");
  const [hasSmsBeenSent, setHasSmsBeenSent] = useState(false);
  const [userPhone, setUserPhone] = useState(null);
  const [isSendingVerification, setIsSendingVerification] = useState(false);
  const [timerActive, setTimerActive] = useState(true);
  const [cameFromSmsMethod, setCameFromSmsMethod] = useState(false);
  const [hasEmailBeenSent, setHasEmailBeenSent] = useState(false);
  const [otpHasBeenSent, setOtpHasBeenSent] = useState(false); 

 

  // Animation state based on timer 

  const getTimerState = () => { 

    if (otpExpired) return "expired"; 

    if (timeLeft <= 5) return "critical"; 

    if (timeLeft <= 15) return "warning"; 

    return "normal"; 

  }; 

 

  const getCardClasses = () => { 

    const baseClass = "forgot-card"; 

    const timerState = getTimerState(); 

     

    if (timerState === "expired") return `${baseClass} timer-expired`; 

    if (timerState === "critical") return `${baseClass} timer-critical timer-active`; 

    if (timeLeft > 0) return `${baseClass} timer-active`; 

    return baseClass; 

  }; 

 

  const getTimerClasses = () => { 

    const timerState = getTimerState(); 

    return `timer timer-${timerState}`; 

  }; 

 

  useEffect(() => { 
    let phone = null;
    if (location.state?.user) {
      const user = location.state.user;
      const rawPhone = user.phone || user.contact || user.contactDetails?.contact || (user.phoneLast10 ? `+63${user.phoneLast10}` : null);
      phone = normalizePhoneNumber(rawPhone);
    }
    setUserPhone(phone);
  }, [location.state]);

  useEffect(() => { 
    if (!timerActive || timeLeft <= 0) {
      if (timeLeft <= 0) {
        setOtpExpired(true);
      }
      return;
    }

    const timer = setInterval(() => { 
      setTimeLeft((prev) => { 
        if (prev <= 1) { 
          setOtpExpired(true); 
          return 0; 
        } 
        return prev - 1; 
      }); 
    }, 1000); 

    return () => clearInterval(timer); 
  }, [timeLeft, timerActive]); 

 

  const formatTime = (sec) => { 

    const minutes = Math.floor(sec / 60); 

    const seconds = sec % 60; 

    return `${minutes}:${seconds.toString().padStart(2, "0")}`; 

  }; 

 

  const isOtpComplete = otp.every((digit) => digit !== ""); 

 

  const handleChange = (value, index) => { 

    if (!/^\d?$/.test(value)) return; 

 

    const newOtp = [...otp]; 

    newOtp[index] = value; 

    setOtp(newOtp); 

    setError(""); 

 

    if (value && index < OTP_LENGTH - 1) { 

      inputsRef.current[index + 1].focus(); 

    } 

  }; 

 

  const handleKeyDown = (e, index) => { 

    if (e.key === "Backspace" && !otp[index] && index > 0) { 

      inputsRef.current[index - 1].focus(); 

    } 

  }; 

 

  const handlePaste = (e) => { 

    const pasteData = e.clipboardData.getData("text").trim().slice(0, OTP_LENGTH); 

    if (/^\d+$/.test(pasteData)) { 

      const pasteArray = pasteData.split(""); 

      const newOtp = Array(OTP_LENGTH).fill(""); 

      pasteArray.forEach((char, i) => { 

        if (i < OTP_LENGTH) newOtp[i] = char; 

      }); 

      setOtp(newOtp); 

      setError(""); 

      const lastFilled = pasteArray.length - 1; 

      inputsRef.current[Math.min(lastFilled, OTP_LENGTH - 1)].focus(); 

    } 

    e.preventDefault(); 

  }; 

 

  const handleVerify = async () => { 

    if (!isOtpComplete) { 

      setError("Please enter all 6 digits"); 

      // Reset OTP boxes when incomplete 

      setOtp(Array(OTP_LENGTH).fill("")); 

      inputsRef.current[0]?.focus(); 

      return; 

    } 

 

    if (otpExpired) { 

      setError("Code has expired. Please request a new code."); 

      // Reset OTP boxes when expired 

      setOtp(Array(OTP_LENGTH).fill("")); 

      inputsRef.current[0]?.focus(); 

      return; 

    } 

 

    setIsVerifying(true); 

 

    try { 

      const result = verifyStoredLoginOtp(otp.join("")); 

      if (!result.success) { 

        setError(result.error); 

        // Reset OTP boxes when incorrect 

        setOtp(Array(OTP_LENGTH).fill("")); 

        inputsRef.current[0]?.focus(); 

        return; 

      }


      clearStoredLoginOtpChallenge();

      const pendingReactivation = getPendingAccountReactivation();
      if (pendingReactivation?.uid || pendingReactivation?.email) {
        try {
          await finalizePendingAccountReactivation({
            uid: pendingReactivation?.uid || auth.currentUser?.uid,
            email: pendingReactivation?.email || auth.currentUser?.email,
            userName: pendingReactivation?.userName || "Admin",
            db,
            apiBase: process.env.REACT_APP_FUNCTIONS_URL || "https://us-central1-auravit-bb843.cloudfunctions.net",
          });
        } catch (error) {
          console.error("Error finalizing pending reactivation after admin login verification:", error);
        }
      }

      // Update lastLogin timestamp after successful OTP verification
      try {
        const user = auth.currentUser;
        if (user) {
          await updateDoc(doc(db, 'users', user.uid), {
            lastLogin: serverTimestamp()
          });
        }
      } catch (error) {
        console.error("Error updating lastLogin after OTP verification:", error);
        // Non-fatal error, continue with login flow
      }

      const stored = JSON.parse(localStorage.getItem("user") || "{}");

      if (stored.uid) {
        await sessionService.trackSession(stored.uid);
        // Clean up old revoked sessions in the background
        sessionService.pruneOldSessions(stored.uid).catch(() => {});
      }

      navigate("/admin-management", { state: { user: stored } });
      sessionStorage.removeItem('freshLoginInProgress'); 

    } catch (err) { 

      console.error("Verification Error:", err); 

      setError(err?.message || "Unable to continue. Please try again."); 

    } finally { 

      setIsVerifying(false); 

    } 

  }; 

 

  const handleResend = async () => { 
    if (resendText === "Sent!" || isSendingVerification) return; 

    try { 
      setIsSendingVerification(true);

      if (verificationMethod === "email") {
        const refreshedChallenge = refreshStoredLoginOtpChallenge(); 
        const emailLower = String(refreshedChallenge.email || "").toLowerCase(); 
        const isDefaultAdmin = emailLower === "auravit@admin.auravit.com"; 
        const recipient = isDefaultAdmin ? "auravit2026@gmail.com" : emailLower; 

        await sendOtpEmail({ 
          email: recipient, 
          otp: refreshedChallenge.otp, 
          purpose: "login", 
          requestId: refreshedChallenge.requestId, 
          expiresAt: refreshedChallenge.expiresAt, 
        }); 
      } else if (verificationMethod === "sms" && userPhone) {
        const refreshedChallenge = refreshStoredLoginOtpChallenge();
        await sendOtpSms({
          phone: userPhone,
          otp: refreshedChallenge.otp,
          purpose: "login",
          requestId: createOtpRequestId("login-sms"),
          expiresAt: refreshedChallenge.expiresAt,
        });
      }

      setOtp(Array(OTP_LENGTH).fill("")); 
      setOtpExpired(false); 
      setTimeLeft(60); 
      inputsRef.current[0]?.focus(); 
      setResendText("Sent!"); 
      setError(""); 
      if (verificationMethod === "sms") {
        setHasSmsBeenSent(true);
      }
      setTimeout(() => setResendText("Resend"), 3000); 
    } catch (err) { 
      console.error("Resend Error:", err); 
      setError(err?.message || "Failed to resend. Please try again."); 
    } finally {
      setIsSendingVerification(false);
    }
  }; 

 

  const handleCancel = async () => { 
    clearStoredLoginOtpChallenge(); 
    localStorage.removeItem("user"); 
    try { 
      await signOut(auth); 
    } catch (err) { 
      console.error("Sign-out error:", err); 
    } 
    navigate("/login"); 
  };

  const handleTryAnotherWay = () => {
    setVerificationMethod("sms");
    setHasSmsBeenSent(false);
    setHasEmailBeenSent(false);
    setOtpHasBeenSent(false);
    setOtp(Array(OTP_LENGTH).fill(""));
    setTimeLeft(60);
    setOtpExpired(false);
    setTimerActive(false);
    setCameFromSmsMethod(false);
  };

  const handleTryAnotherWayBack = () => {
    setVerificationMethod("email");
    setHasSmsBeenSent(false);
    setHasEmailBeenSent(false);
    setOtpHasBeenSent(false);
    setOtp(Array(OTP_LENGTH).fill(""));
    setTimeLeft(60);
    setOtpExpired(false);
    setTimerActive(false);
    setCameFromSmsMethod(true);
  };

  const handleSendEmail = async () => {
    if (isSendingVerification) return;

    try {
      setIsSendingVerification(true);
      const refreshedChallenge = refreshStoredLoginOtpChallenge();
      await sendOtpEmail({
        email: location.state?.otpEmail || location.state?.email || "your registered email",
        otp: refreshedChallenge.otp,
        purpose: "login",
        requestId: createOtpRequestId("login-email"),
        expiresAt: refreshedChallenge.expiresAt,
      });

      setError("");
      setOtp(Array(OTP_LENGTH).fill(""));
      setTimeLeft(60);
      setOtpExpired(false);
      setTimerActive(true);
      setHasEmailBeenSent(true);
      setOtpHasBeenSent(true);
    } catch (e) {
      console.error("Send Email OTP error", e);
      setError("Unable to send OTP email at the moment.");
    } finally {
      setIsSendingVerification(false);
    }
  };

  const handleSendSms = async () => {
    if (isSendingVerification) return;

    try {
      setIsSendingVerification(true);
      const refreshedChallenge = refreshStoredLoginOtpChallenge();
      await sendOtpSms({
        phone: userPhone,
        otp: refreshedChallenge.otp,
        purpose: "login",
        requestId: createOtpRequestId("login-sms"),
        expiresAt: refreshedChallenge.expiresAt,
      });

      setError("");
      setOtp(Array(OTP_LENGTH).fill(""));
      setTimeLeft(60);
      setOtpExpired(false);
      setTimerActive(true);
      setHasSmsBeenSent(true);
      setOtpHasBeenSent(true);
    } catch (e) {
      console.error("Send SMS OTP error", e);
      setError("Unable to send OTP SMS at the moment.");
    } finally {
      setIsSendingVerification(false);
    }
  }; 

 

  return ( 

    <> 

    <div className="verification-logo-container"> 

      <img 

        src={logo} 

        alt="AuraVit" 

        className="verification-logo" 

        onClick={() => navigate("/")} 

      /> 

    </div> 

    <div className="verification-container"> 

      <div className="verification-card"> 

        <h1 className="verification-title">Enter Verification Code</h1> 

        <p className="verification-subtitle"> 
          Enter 6-digit code we sent to: <strong>{verificationMethod === "sms" ? userPhone : emailDisplay}</strong> 
        </p> 

 

        <div className={`verification-otp-inputs ${error ? "shake" : ""}`}> 

          {otp.map((digit, index) => ( 

            <input 

              key={index} 

              ref={(el) => (inputsRef.current[index] = el)} 

              type="text" 

              maxLength="1" 

              value={digit} 

              onChange={(e) => handleChange(e.target.value, index)} 

              onKeyDown={(e) => handleKeyDown(e, index)} 

              onPaste={handlePaste} 

              className={`verification-otp-input ${error && !digit ? "error" : ""}`} 

              disabled={isVerifying} 

              autoFocus={index === 0} 

            /> 

          ))} 

        </div> 

 

        {error && <div className="verification-error-text">{error}</div>} 

 

        {otpExpired && ( 

          <div className="verification-error-text">Code has expired. Please request a new one.</div> 

        )} 

 

        {timerActive && otpHasBeenSent && ( 

          <p className="verification-timer-section"> 

            Code expires in <span className={`verification-timer ${otpExpired ? "expired" : ""}`}>{formatTime(timeLeft)}</span> 

          </p> 

        )} 

 

        {verificationMethod === "email" ? (
          <p className="verification-resend-section"> 
            {cameFromSmsMethod ? (
              hasEmailBeenSent ? (
                <>Didn't receive a code?{" "}
                <span className={`verification-resend-link ${isSendingVerification ? "disabled" : ""}`} onClick={handleResend} style={{ pointerEvents: isSendingVerification ? "none" : "auto", opacity: isSendingVerification ? 0.5 : 1 }}>{resendText}</span>
              </>
              ) : (
                <span className={`verification-resend-link ${isSendingVerification ? "disabled" : ""}`} onClick={handleSendEmail} style={{ pointerEvents: isSendingVerification ? "none" : "auto", opacity: isSendingVerification ? 0.5 : 1 }}>Send Email</span>
              )
            ) : (
              <>Didn't receive a code?{" "}
              <span className={`verification-resend-link ${isSendingVerification ? "disabled" : ""}`} onClick={handleResend} style={{ pointerEvents: isSendingVerification ? "none" : "auto", opacity: isSendingVerification ? 0.5 : 1 }}>{resendText}</span>
            </>
            )}
          </p>
        ) : (
          <p className="verification-resend-section">
            {hasSmsBeenSent ? (
              <>Didn't receive a code?{" "}
              <span className={`verification-resend-link ${isSendingVerification ? "disabled" : ""}`} onClick={handleResend} style={{ pointerEvents: isSendingVerification ? "none" : "auto", opacity: isSendingVerification ? 0.5 : 1 }}>{resendText}</span></>
            ) : (
              <span className={`verification-resend-link ${isSendingVerification ? "disabled" : ""}`} onClick={handleSendSms} style={{ pointerEvents: isSendingVerification ? "none" : "auto", opacity: isSendingVerification ? 0.5 : 1 }}>Send SMS</span>
            )}
          </p>
        )}

        {verificationMethod === "sms" && (
          <span className="back-link" onClick={handleTryAnotherWayBack} style={{ textDecoration: "underline" }}>
            Try another way
          </span>
        )}

        {verificationMethod === "email" && userPhone && (
          <span className="back-link" onClick={handleTryAnotherWay} style={{ textDecoration: "underline" }}>
            Try another way
          </span>
        )}

        <button className="verification-verify-btn" onClick={handleVerify} disabled={isVerifying || !isOtpComplete || otpExpired}> 
          {isVerifying ? "Verifying..." : "Verify"} 
        </button> 

        <button
          className="verification-cancel-btn"
          onClick={handleCancel}
        >
          Cancel
        </button> 

      </div> 

    </div> 

    </> 

  ); 

} 

 

 